import {Box} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {HorizontalAlignment} from '@mintdata/mint-kit/api/models/HorizontalAlignment';
import {VerticalAlignment} from '@mintdata/mint-kit/api/models/VerticalAlignment';
import {IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';

export abstract class AlignmentMenu
{
    public static build(target:Box):Array<IContextMenuItem>
    {
        const {surfaceArea} = controllers.ui;

        const horizontalMenuItems = [
            {
                label: 'Left',
                handler: () =>
                {
                    surfaceArea.alignSelectedBoxesHorizontally(HorizontalAlignment.LEFT);
                }
            },
            {
                label: 'Center',
                handler: () =>
                {
                    surfaceArea.alignSelectedBoxesHorizontally(HorizontalAlignment.CENTER);
                }
            },
            {
                label: 'Right',
                handler: () =>
                {
                    surfaceArea.alignSelectedBoxesHorizontally(HorizontalAlignment.RIGHT);
                }
            }
        ];

        const verticalMenuItems = [
            {
                label: 'Top',
                handler: () =>
                {
                    surfaceArea.alignSelectedBoxesVertically(VerticalAlignment.TOP);
                }
            },
            {
                label: 'Middle',
                handler: () =>
                {
                    surfaceArea.alignSelectedBoxesVertically(VerticalAlignment.MIDDLE);
                }
            },
            {
                label: 'Bottom',
                handler: () =>
                {
                    surfaceArea.alignSelectedBoxesVertically(VerticalAlignment.BOTTOM);
                }
            }
        ];

        return [
            {
                label: '',
                isSeparator: true
            },
            {
                label: 'Align horizontally',
                dataSource: horizontalMenuItems,
                isDisabled: !surfaceArea.isAlignmentActionAvailable()
            },
            {
                label: 'Align vertically',
                dataSource: verticalMenuItems,
                isDisabled: !surfaceArea.isAlignmentActionAvailable()
            }
        ];
    }
}
